import handlebars from 'handlebars';
import hijriMoment from 'moment-hijri';
import Vue from 'vue';
import { convertEnToArChar, convertNumberToText } from '../helpers/utils';

handlebars.registerHelper('hindiNumber', value =>
  (value || '').toString()
    .replace(/[0-9]/g, convertEnToArChar)
);

handlebars.registerHelper('hindiNumbers', options =>
  options
    .fn(options.data.root)
    .toString()
    .replace(/[0-9]/g, convertEnToArChar)
);

handlebars.registerHelper('hijriDate', (value) => {
  if (!value) return '';
  const hijriDate = hijriMoment(value)
    .format('iYYYY/iMM/iDهـ');
  const gregorianDate = hijriMoment(value)
    .format('YYYY/MM/Dمـ');
  return hijriDate.includes('NaN') ? gregorianDate : hijriDate;
});

handlebars.registerHelper('gregorianDate', date => (date || '').split('-')
  .join('/')
  .replace(/[0-9]/g, convertEnToArChar) + 'م');

handlebars.registerHelper('dateDifference', (date1, date2, options) => {
  if (!date1) return 0;
  if (options === undefined) {
    /* eslint-disable  no-param-reassign */
    options = date2;
    date2 = new Date();
    /* eslint-disable  no-param-reassign */
  }
  return (new Date(date2)
    .setHours(0, 0, 0, 0) - new Date(date1)
      .setHours(0, 0, 0, 0)) / 86400000;
});

handlebars.registerHelper('compare', (left, operator, right, options) => {
  // eslint-disable-next-line no-undef
  if (arguments.length < 3) {
    throw new Error(`'compare' helper requires at least 2 parameters`);
  }

  if (options === undefined) {
    /* eslint-disable  no-param-reassign */
    options = right;
    right = operator;
    operator = '===';
    /* eslint-disable  no-param-reassign */
  }

  const operators = {
    // eslint-disable-next-line eqeqeq
    '==': (l, r) => l == r,
    '===': (l, r) => l === r,
    // eslint-disable-next-line eqeqeq
    '!=': (l, r) => l != r,
    '!==': (l, r) => l !== r,
    '<': (l, r) => l < r,
    '>': (l, r) => l > r,
    '<=': (l, r) => l <= r,
    '>=': (l, r) => l >= r,
    // eslint-disable-next-line eqeqeq,valid-typeof
    typeof: (l, r) => typeof l == r,
  };

  if (!operators[operator]) {
    throw new Error(`'compare' helper doesn't support the operator '${operator}'`);
  }

  return operators[operator](left, right);
});

handlebars.registerHelper('increment', value => +value + 1);
handlebars.registerHelper('incrementGlobalVar', (name, incrementWith) => {
  window[name] = window[name] + (isNaN(incrementWith) ? 1 : incrementWith);
});
handlebars.registerHelper('var', (name, value) => {
  window[name] = value;
});
handlebars.registerHelper('not', value => !value);

handlebars.registerHelper('plural', (number, single, double, plural) => {
  if (+number === 2) return double;
  if (+number > 2 && +number <= 10) return `${number} ${plural}`;
  if (+number > 10) return `${number} ${single}`;
  return single;
});

handlebars.registerHelper('isArrayHasItem', (array, item) => {
  if (!array) return false;
  const arr = Array.isArray(array) ? array : JSON.parse(array);
  return arr.indexOf(item) !== -1;
});
handlebars.registerHelper('isArrayHasAtLeastOneItemFromOtherArray', (array, items) => {
  if (!array || !items) return false;
  const arr = Array.isArray(array) ? array : JSON.parse(array);
  const itemsArr = Array.isArray(items) ? items : JSON.parse(items);
  return arr.some(item => itemsArr.indexOf(item) != -1);
});

handlebars.registerHelper('filterByExistsProp', (array, propName, value, options) =>
  (array || []).filter(item => (options === undefined && item[propName]) || item[propName] === value)
);
handlebars.registerHelper(
  'checkFilteredByExistsPropLength',
  (array, propName, number, value, options) => (array || []).filter(item => (options === undefined && item[propName]) || item[propName] === value).length == number
);
handlebars.registerHelper('filteredArrayLength',
  (array, propName, value, options) => (array || []).filter(item => (options === undefined && item[propName]) || item[propName] === value).length
);
handlebars.registerHelper(
  'convertNumberInsideStringToText',
  stringWithNumber => (stringWithNumber || '').toString()
    .split(' ')
    .map((i) => {
      if (isNaN(i)) return i;
      let number = parseFloat((+i).toFixed(3))
        .toString();
      let fractionValue = number.split('.')[1] || '';
      let fractionLength = fractionValue.length;
      let fractionInText = (fractionLength == 1 ? ' مِن عشرة' : (fractionLength == 2 ? ' مِن مئة' : (fractionLength == 3 ? ' مِن ألف' : '')));
      let numberInText = `${convertNumberToText(+number)} ${fractionLength > 0 ? 'و' + convertNumberToText(+fractionValue) + fractionInText : ''} `;
      return numberInText;
    })
    .join(' ')
);
handlebars.registerHelper(
  'convertMoneyInsideStringToText',
  (stringWithMoney, currency) => (stringWithMoney || '').toString()
    .split(' ')
    .map((i) => {
      currency = typeof currency == 'string' ? currency : 'ريال سعودي';
      if (isNaN(i)) return i;
      let number = (+i).toFixed(2)
        .toString();
      let fractionValue = parseInt(number.split('.')[1]);
      let returnValue = `(${number.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}) ${convertNumberToText(number.split('.')[0])}`;
      let hallelah = (currency == 'ريال سعودي' && number.indexOf('.') != -1 && +fractionValue !== 0) ? ` و ${convertNumberToText(fractionValue)} هلله` : ``;
      if (currency) returnValue = `${returnValue} ${currency}${hallelah}`;
      return returnValue;
    })
    .join(' ')
);

handlebars.registerHelper('getItemFromArray', (array, index) => array[parseInt(index)]);

handlebars.registerHelper('sortByBirthdate', (array, key, direction = 'asc') => {
  const sortedArray = array.sort((a, b) => hijriMoment(a[key])
    .format('YYYY-MM-DD') - hijriMoment(b[key])
      .format('YYYY-MM-DD'));

  if (direction === 'desc') {
    return sortedArray.reverse();
  }

  return sortedArray;
});

handlebars.registerHelper('sortByArabicName', (array, key, direction = 'asc') => {
  const sortedArray = array.sort((a, b) => a[key].localeCompare(b[key], ['ar']));

  if (direction === 'desc') {
    return sortedArray.reverse();
  }

  return sortedArray;
});

// custom Helpers: نموذج المستندات
handlebars.registerHelper('reduceAttachmentsRequests', (attachments) => {
  const requests = [];

  attachments.forEach((attachment) => {
    attachment.attachmentsData.forEach((request) => {
      const isFoundIndex = requests.findIndex(item => item.attachmentRequestType === request.attachmentRequestType);

      if (isFoundIndex !== -1) {
        requests[isFoundIndex].attachments[attachment.objectKey] = {
          ...attachment,
          requestDetils: request,
        };
      } else {
        requests.push({
          ...request,
          attachments: {
            [attachment.objectKey]: {
              ...attachment,
              requestDetils: request,
            },
          },
        });
      }
    });
  });

  return requests.map(r => ({
    ...r,
    attachments: Object.values(r.attachments),
  }));
});

Vue.handlebars = Vue.prototype.handlebars = (template = '', model = {}, options = {}) => {
  try {
    return handlebars.compile(template, {
      ...options,
      noEscape: true,
    })(model);
  } catch (error) {
    return new Error(`حدثت مشكلة أثناء تحديث الصياغة\nوصف المشكلة: ${error}`);
  }
};
